(() => {
  'use strict';

  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 767px)');
  const startKey = 'p351-mobile-inbox-v2-start';
  const actionKey = 'p351-mobile-inbox-v2-engaged';
  const delayMs = 10000;
  const now = Date.now();
  let start = now;
  let engaged = false;

  try {
    const previousStart = Number(sessionStorage.getItem(startKey));
    if (previousStart > 0 && previousStart <= now && now - previousStart < 86400000) {
      start = previousStart;
    } else {
      sessionStorage.setItem(startKey, String(now));
      sessionStorage.removeItem(actionKey);
    }
    engaged = sessionStorage.getItem(actionKey) === '1';
  } catch (_) {
    // Storage may be disabled; the delay still works for the current page.
  }

  let launcherStyled = false;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const eligible = () => engaged && Date.now() - start >= delayMs;
  const chatExpanded = () => Boolean(document.querySelector(
    'inbox-online-store-chat[is-open="true"], shopify-chat[is-open="true"], #ShopifyChat[is-open="true"]'
  ));
  const updateVisibility = () => {
    if (!mobile.matches || designMode || chatExpanded() || (eligible() && launcherStyled)) {
      root.classList.remove('p351-mobile-inbox-pending');
    } else {
      root.classList.add('p351-mobile-inbox-pending');
    }
  };

  const events = ['touchstart', 'pointerdown', 'keydown', 'wheel', 'scroll'];
  const noteAction = (event) => {
    if (event.isTrusted === false || engaged) return;
    engaged = true;
    try { sessionStorage.setItem(actionKey, '1'); } catch (_) {}
    events.forEach((type) => window.removeEventListener(type, noteAction));
    updateVisibility();
  };

  if (window.Shopify && window.Shopify.designMode) {
    root.classList.remove('p351-mobile-inbox-pending');
  } else {
    events.forEach((type) => window.addEventListener(type, noteAction, { passive: true }));
    updateVisibility();
    const remaining = Math.max(0, delayMs - (Date.now() - start));
    window.setTimeout(updateVisibility, remaining + 20);
    window.addEventListener('pageshow', updateVisibility);
    document.addEventListener('visibilitychange', updateVisibility);
    mobile.addEventListener('change', () => {
      updateVisibility();
      queueScan();
    });
  }


  const chatHosts = '#shopify-chat, #ShopifyChat, shopify-chat, inbox-online-store-chat';
  const activatorSelector = 'button.chat-toggle, button.activator';
  const styleMarker = 'data-p351-mobile-inbox-style';
  const shadowCSS = "\n@media screen and (max-width: 767px) {\n  button.chat-toggle.p351-inbox-icon-ready,\n  button.activator.p351-inbox-icon-ready {\n    box-sizing: border-box !important;\n    width: 44px !important;\n    min-width: 44px !important;\n    max-width: 44px !important;\n    height: 44px !important;\n    min-height: 44px !important;\n    max-height: 44px !important;\n    padding: 0 !important;\n    border: 1px solid rgba(255,255,255,.22) !important;\n    border-radius: 50% !important;\n    background: rgba(18,20,23,.62) !important;\n    color: #fff !important;\n    box-shadow: none !important;\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 0 !important;\n    overflow: hidden !important;\n    font-size: 0 !important;\n    line-height: 0 !important;\n  }\n  button.p351-inbox-icon-ready > :not(svg.p351-inbox-icon) {\n    display: none !important;\n  }\n  button.p351-inbox-icon-ready::before,\n  button.p351-inbox-icon-ready::after {\n    content: none !important;\n  }\n  button.p351-inbox-icon-ready > svg.p351-inbox-icon {\n    display: block !important;\n    flex: 0 0 20px !important;\n    width: 20px !important;\n    min-width: 20px !important;\n    max-width: 20px !important;\n    height: 20px !important;\n    min-height: 20px !important;\n    max-height: 20px !important;\n    margin: 0 auto !important;\n    padding: 0 !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    pointer-events: none !important;\n    color: #fff !important;\n    fill: none !important;\n    stroke: #fff !important;\n  }\n  button.p351-inbox-icon-ready > svg.p351-inbox-icon path {\n    stroke: #fff !important;\n    fill: none !important;\n  }\n  button.chat-toggle:not(.p351-inbox-icon-ready),\n  button.activator:not(.p351-inbox-icon-ready) {\n    visibility: hidden !important;\n    opacity: 0 !important;\n    pointer-events: none !important;\n  }\n}";
  const observedRoots = new WeakSet();
  let scanQueued = false;

  const styleButton = (button) => {
    if (!mobile.matches) return;
    if (!button.getAttribute('aria-label')) {
      button.setAttribute('aria-label', button.textContent.trim() || 'Chat with us');
    }
    if (!button.querySelector(':scope > svg.p351-inbox-icon')) {
      const ns = 'http://www.w3.org/2000/svg';
      const icon = document.createElementNS(ns, 'svg');
      icon.classList.add('p351-inbox-icon');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
      const path = document.createElementNS(ns, 'path');
      path.setAttribute('d', 'M7.9 20A9 9 0 1 0 4 16.1L2 22Z');
      path.setAttribute('stroke', '#ffffff');
      path.setAttribute('stroke-width', '1.85');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      path.setAttribute('fill', 'none');
      icon.appendChild(path);
      button.appendChild(icon);
    }
    button.classList.add('p351-inbox-icon-ready');
    if (button.querySelector(':scope > svg.p351-inbox-icon')) {
      launcherStyled = true;
    }
  };

  const inspect = (scope, depth) => {
    if (!scope || depth > 8) return;
    if (scope.shadowRoot) inspect(scope.shadowRoot, depth + 1);
    if (!scope.querySelectorAll) return;
    if (scope instanceof ShadowRoot) {
      if (!observedRoots.has(scope)) {
        observedRoots.add(scope);
        new MutationObserver(queueScan).observe(scope, { childList: true, subtree: true });
      }
      if (scope.querySelector(activatorSelector) && !scope.querySelector('style[' + styleMarker + ']')) {
        const sheet = document.createElement('style');
        sheet.setAttribute(styleMarker, '');
        sheet.textContent = shadowCSS;
        scope.appendChild(sheet);
      }
    }
    scope.querySelectorAll(activatorSelector).forEach(styleButton);
    scope.querySelectorAll('*').forEach((child) => {
      if (child.shadowRoot) inspect(child.shadowRoot, depth + 1);
    });
  };

  function scan() {
    launcherStyled = false;
    document.querySelectorAll(chatHosts).forEach((host) => {
      if (host.tagName.toLowerCase() === 'inbox-online-store-chat' &&
          location.pathname.startsWith('/products/')) {
        host.classList.add('p351-mobile-inbox-product');
      }
      inspect(host, 0);
    });
    updateVisibility();
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueScan, { once: true });
  }
  scan();
})();
